import React from 'react';
import logo from './logo.svg';
import './App.css';
import { Clock } from './stories/clock/Clock';

function App() {
  return (
    <div className="App">
      <Clock />
    </div>
  );
}

export default App;
